import styled from 'styled-components';
import { Formik } from 'formik';

export const Form = styled(Formik)`
  input {
    width: 100%;
    height: 4.8rem;
  }
`;

export const FormBody = styled.div`
  padding: 32px;
  margin-top: 70px;
  margin-right: 10px;

  input[type='number'] {
    color: ${(props) => props.theme.config.colors.gray_100};
  }

  &::-webkit-scrollbar {
    background: transparent;
    width: 5px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.config.colors.primary_100};
    border-radius: 20px;
    width: 5px;
  }
`;

export const FooterButtons = styled.div`
  display: flex;
  justify-content: flex-end;
`;
